const features = [
  {
    icon: "ri-drop-line",
    tint: "bg-accent-100 text-accent-700",
    name: "一键去水印",
    desc: "保存无水印原片到本地，追完不占内存焦虑",
    metric: "热度 No.1",
  },
  {
    icon: "ri-link",
    tint: "bg-secondary-100 text-secondary-800",
    name: "链接解析",
    desc: "粘贴分享链接，直出可播地址，随看随切",
    metric: "通道已扩容",
  },
  {
    icon: "ri-time-line",
    tint: "bg-primary-100 text-primary-700",
    name: "倍速播放",
    desc: "0.5x–4x 自由调速，片段循环，重点不放过",
    metric: "支持片段循环",
  },
  {
    icon: "ri-record-circle-line",
    tint: "bg-accent-100 text-accent-700",
    name: "高清录屏",
    desc: "跟随直播自动分段，长时录制更省心不卡顿",
    metric: "直播跟随模式",
  },
  {
    icon: "ri-chat-3-line",
    tint: "bg-secondary-100 text-secondary-800",
    name: "弹幕聚合",
    desc: "多端弹幕同屏对齐，评论区氛围感拉满",
    metric: "双端同步对齐",
  },
  {
    icon: "ri-apps-2-line",
    tint: "bg-primary-100 text-primary-700",
    name: "全局聚合",
    desc: "视频、直播、弹幕一站式吃瓜，一个入口全包",
    metric: "一站式入口",
  },
];

const chips = ["去水印", "解析", "倍速", "录屏", "弹幕", "聚合"];

export default function FeatureHero() {
  return (
    <section id="play" className="relative overflow-hidden">
      {/* 柔和分层背景 */}
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            "radial-gradient(60rem 32rem at 18% 8%, oklch(var(--accent-100) / 0.55), transparent 60%), radial-gradient(52rem 30rem at 88% 12%, oklch(var(--primary-100) / 0.55), transparent 60%)",
        }}
      />
      <div className="relative mx-auto w-full max-w-7xl px-4 pb-10 pt-10 md:px-6 md:pb-14 md:pt-14">
        <div className="mx-auto max-w-3xl text-center">
          <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-background-50 px-3 py-1 text-xs font-medium text-primary-700 ring-1 ring-primary-200">
            <i className="ri-flashlight-line" />
            吃瓜神器 · 视频 / 直播全能玩法专题
          </span>
          <h2 className="mt-5 text-3xl font-black leading-tight text-foreground-950 md:text-5xl">
            全网视频 / 直播
            <br className="md:hidden" />
            <span className="text-primary-600">一个吃瓜神器就够</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
            去水印、解析、倍速、录屏、弹幕、聚合六大玩法一个入口全包。追剧看直播、
            存干货、二创找素材，掌握这套吃瓜神器玩法，吃瓜体验直接上一个台阶。
          </p>
          <div className="mt-5 flex flex-wrap items-center justify-center gap-2">
            {chips.map((c, i) => (
              <span
                key={c}
                className="whitespace-nowrap rounded-full bg-background-100 px-3 py-1 text-xs text-foreground-700"
              >
                <span className="mr-1 text-accent-600">{i + 1}</span>
                {c}
              </span>
            ))}
          </div>
        </div>

        {/* 多卡并列首屏 */}
        <div className="mt-9 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3 md:gap-4">
          {features.map((f) => (
            <article
              key={f.name}
              className="group flex items-start gap-3 rounded-2xl border border-background-200 bg-background-50/90 p-4 transition-all hover:-translate-y-1 hover:border-secondary-300 md:p-5"
            >
              <span
                className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl ${f.tint}`}
              >
                <i className={`${f.icon} text-xl`} />
              </span>
              <div className="min-w-0">
                <div className="flex items-center justify-between gap-2">
                  <h3 className="whitespace-nowrap text-base font-bold text-foreground-950">
                    {f.name}
                  </h3>
                  <span className="hidden shrink-0 whitespace-nowrap rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-800 sm:inline">
                    {f.metric}
                  </span>
                </div>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">
                  {f.desc}
                </p>
              </div>
            </article>
          ))}
        </div>

        {/* 热度数据带 */}
        <div className="mt-8 grid grid-cols-2 gap-3 md:grid-cols-4">
          {[
            { n: "120w+", label: "本周去水印保存", icon: "ri-drop-line" },
            { n: "3.6w", label: "解析通道稳定出片", icon: "ri-link" },
            { n: "86%", label: "倍速回放使用率", icon: "ri-time-line" },
            { n: "9.2w", label: "同屏弹幕互动", icon: "ri-chat-3-line" },
          ].map((s) => (
            <div
              key={s.label}
              className="flex items-center gap-3 rounded-2xl border border-background-200 bg-background-50 px-4 py-3"
            >
              <i className={`${s.icon} text-lg text-accent-600`} />
              <div>
                <p className="font-display-latin text-lg font-bold leading-none text-foreground-950" style={{ fontFamily: "var(--font-display-latin)" }}>
                  {s.n}
                </p>
                <p className="mt-1 text-xs text-foreground-600">{s.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}